import React, { Component } from "react";
import styled from "styled-components";

import { WorkspacePlanTier } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";
import { ShowUpgradeDialog } from "./Dialogs/BaseDialog";
import UpgradeIcon from "js/Components/UpgradeIcon";

const StyledUpgradeIcon = styled(UpgradeIcon)`
    margin-left: auto;
    cursor: pointer;
`;

class ProBadge extends Component {
    constructor(props) {
        super(props);

        const { upgradeType, analytics, workspaceId } = props;

        if (!workspaceId) {
            throw new Error("workspaceId is required");
        }

        if (!analytics) {
            throw new Error("analytics is required");
        }

        if (analytics && !analytics.cta) {
            throw new Error("analytics.cta is required");
        }

        this.state = {
            upgradeType: upgradeType || UpgradePlanDialogType.UPGRADE_PLAN
        };
    }

    handleClick = event => {
        const { beforeShowDialogCallback, analytics, workspaceId } = this.props;
        const { upgradeType } = this.state;

        if (upgradeType === UpgradePlanDialogType.TEAM_NOOP) return;

        event.stopPropagation();

        if (beforeShowDialogCallback) {
            beforeShowDialogCallback();
        }

        ShowUpgradeDialog({
            type: upgradeType,
            analytics,
            workspaceId
        });
    }

    render() {
        const { style = {}, show } = this.props;
        const { upgradeType } = this.state;
        const isTeamBadge = upgradeType === UpgradePlanDialogType.UPGRADE_PLAN_TO_TEAM || upgradeType === UpgradePlanDialogType.TEAM_NOOP;
        if (isTeamBadge && WorkspaceController.plan.tier !== WorkspacePlanTier.BASIC && show) {
            return (
                <StyledUpgradeIcon onClick={this.handleClick} />
            );
        }
        if (show) {
            return (
                <div
                    className="pro-badge" style={style}
                    onClick={this.handleClick}
                >PRO</div>
            );
        } else {
            return null;
        }
    }
}

export default ProBadge;
